import { BlocksContent } from '@strapi/blocks-react-renderer';

import { CaseSlideItem } from '@/components/CasesChunkedSlider/types';
import { CasesScrollItemDto } from '@/components/Partnership/CasesSliderScroll/types';

const stringToBlocksContent = (text: string): BlocksContent => [
	{
		type: 'paragraph',
		children: [{ type: 'text', text }]
	}
];

const resolveTitle = (caseItem: CasesScrollItemDto): BlocksContent | undefined => {
	if (caseItem.slideTitle) return stringToBlocksContent(caseItem.slideTitle);

	return undefined;
};

export const mapCasesScrollItemToSlideItem = (caseItem: CasesScrollItemDto): CaseSlideItem => ({
	id: caseItem.id,
	subtitle: caseItem.tabLabel,
	title: resolveTitle(caseItem),
	url: caseItem.cta?.url,
	image: caseItem.image,
	videoUrl: caseItem.videoUrl,
	thumbnailUrl: caseItem.videoThumbnailUrl
});
